// extracted by mini-css-extract-plugin
module.exports = {"courierSelectorBtn":"ShipmentCourier_courierSelectorBtn__-eB3-","courierSelectorArrow":"ShipmentCourier_courierSelectorArrow__2C17P"};